import { useHistory } from "react-router-dom";
import _isFunction from "lodash/isFunction";
import _some from "lodash/some";

type Permissions = (boolean | (() => boolean))[];

export default function usePagePermission(
  permissions: Permissions,
  redirect: string
) {
  const history = useHistory();
  const hasPermission = _some(permissions, (permission) => {
    return _isFunction(permission) ? permission() : permission;
  });

  if (!hasPermission) history.push(redirect);
}
